import type { ReactNode } from 'react'
import type { ViewComponent } from './viewTypes'
import { packRows } from './packRows'
import './dashboard.css'

/** Keep authored order and bindings; give adjacent KPIs a single, calm summary surface. */
export function DashboardGrid({ components, compact, render }: {
    components: ViewComponent[]
    compact: boolean
    render: (component: ViewComponent) => ReactNode
}) {
    const placed = packRows(components)
    const groups: Array<typeof placed> = []
    for (const item of placed) {
        const previous = groups[groups.length - 1]
        const last = previous?.[previous.length - 1]
        if (item.component.type === 'metric' && last?.component.type === 'metric'
            && item.row === last.row && item.component.rowSpan === last.component.rowSpan
            && item.col === last.col + last.component.colSpan) {
            previous!.push(item)
        } else {
            groups.push([item])
        }
    }
    return <div className="dashboard-layout" data-viewport={compact ? 'compact' : 'wide'}>
        <div className="dashboard-grid">
            {groups.map((group, index) => {
                const first = group[0]!
                const metrics = first.component.type === 'metric'
                const span = group.reduce((sum, item) => sum + item.component.colSpan, 0)
                return <div key={index} data-dashboard-slot={metrics ? 'metrics' : first.component.type}
                    className={metrics ? 'dashboard-metrics' : 'dashboard-panel'}
                    style={{ gridColumn: `${first.col} / span ${span}`, gridRow: `${first.row} / span ${first.component.rowSpan}` }}>
                    {group.map((item, i) => <div key={i} className={metrics ? 'dashboard-metric' : 'dashboard-content'}>{render(item.component)}</div>)}
                </div>
            })}
        </div>
    </div>
}
